function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export function chooseDomElementGetter(opts, props) {
  var domElementGetter;

  if (props.domElement) {
    domElementGetter = function domElementGetter() {
      return props.domElement;
    };
  } else if (props.domElementGetter) {
    domElementGetter = props.domElementGetter;
  } else if (opts.domElementGetter) {
    domElementGetter = opts.domElementGetter;
  } else {
    domElementGetter = defaultDomElementGetter(props);
  }

  if (typeof domElementGetter !== "function") {
    throw Error("single-spa's dom-element-getter-helpers was given an invalid domElementGetter for application or parcel '".concat(props.name, "'. Expected a function, received ").concat(_typeof(domElementGetter)));
  }

  return function () {
    var domElement = domElementGetter(props);

    if (!(domElement instanceof HTMLElement)) {
      throw Error("single-spa's dom-element-getter-helpers: domElementGetter returned an invalid dom element for application or parcel '".concat(props.name, "'. Expected HTMLElement, received ").concat(_typeof(domElement)));
    }

    return domElement;
  };
}

function defaultDomElementGetter(props) {
  var appName = props.appName || props.name;

  if (!appName) {
    throw Error("single-spa's dom-element-getter-helpers was not given an application name as a prop, so it can't make a unique dom element container for the react application");
  }

  var htmlId = "single-spa-application:".concat(appName);
  return function defaultDomEl() {
    var domElement = document.getElementById(htmlId);

    if (!domElement) {
      domElement = document.createElement("div");
      domElement.id = htmlId;
      document.body.appendChild(domElement);
    }

    return domElement;
  };
}
